<template>
  <div class="text-center">
    <q-spinner color="primary" size="3em" />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss"></style>
